var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.85,
    height: 59.78,
    viewBox: "0 0 51.85 59.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.29,18.25c-2.91,0-5.63-1.38-7.35-3.72h-17.17c-1.72,2.33-4.44,3.72-7.35,3.72-5.03,0-9.12-4.09-9.12-9.12S5.39,0,10.43,0c2.91,0,5.63,1.38,7.35,3.72h17.17c1.72-2.33,4.44-3.72,7.35-3.72,3.51,0,6.65,1.97,8.2,5.13.09.19.08.42-.03.61-.11.18-.31.29-.53.29h-8.36l-1.79,3.09,1.79,3.09h8.36c.22,0,.42.11.53.29.11.18.13.41.03.61-1.55,3.16-4.69,5.13-8.2,5.13Zm-24.84-4.97h17.81c.21,0,.4.1.52.27,1.47,2.16,3.9,3.45,6.51,3.45s5.11-1.33,6.56-3.53h-7.64c-.22,0-.43-.12-.54-.31l-2.15-3.72c-.11-.19-.11-.43,0-.62l2.15-3.72c.11-.19.32-.31.54-.31h7.64c-1.45-2.2-3.88-3.53-6.56-3.53s-5.04,1.29-6.51,3.45c-.12.17-.31.27-.52.27h-17.81c-.21,0-.4-.1-.52-.27-1.47-2.16-3.9-3.45-6.51-3.45-4.34,0-7.88,3.53-7.88,7.88s3.53,7.88,7.88,7.88c2.61,0,5.04-1.29,6.51-3.45.12-.17.31-.27.52-.27Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.57,13.47h-4.29c-.22,0-.43-.12-.54-.31l-2.15-3.72c-.11-.19-.11-.43,0-.62l2.15-3.72c.11-.19.32-.31.54-.31h4.29c.22,0,.43.12.54.31l2.15,3.72c.11.19.11.43,0,.62l-2.15,3.72c-.11.19-.32.31-.54.31Zm-3.93-1.25h3.57l1.79-3.09-1.79-3.09h-3.57l-1.79,3.09,1.79,3.09Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.12,52.94H4.73c-2.55,0-4.51-2.23-4.2-4.76l2.62-20.79c.27-2.11,2.06-3.7,4.2-3.7h37.14c2.13,0,3.93,1.59,4.2,3.7l2.62,20.79c.32,2.53-1.65,4.76-4.2,4.76Z",
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.76,
    y1: 46.42,
    x2: 51.09,
    y2: 46.42,
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.07,
    y1: 38.32,
    x2: 1.79,
    y2: 38.32,
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.18,
    y1: 31.19,
    x2: 2.68,
    y2: 31.19,
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.3,
    y1: 23.69,
    x2: 16.88,
    y2: 46.41,
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.56,
    y1: 23.69,
    x2: 34.98,
    y2: 46.41,
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.1,52.95v3.08c0,1.8-1.46,3.26-3.26,3.26h-9.82c-1.8,0-3.26-1.46-3.26-3.26v-3.08",
    fill: "none",
    stroke: "#f0f0f0",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModule);
export default __webpack_public_path__ + "static/media/module.4f724f9770572f9a7585dd68ed0482e4.svg";
export { ForwardRef as ReactComponent };